import React, { Component } from 'react'
import { extendObservable } from 'mobx'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'

import ProjectsListingStore from './projects-listing.store'

import Pagination from '@components/Pagination'
import Error from '@components/Error/NoContent'
import Spinner from '@components/spinner'
import ProjectsTable from './ProjectsTable'

class Projects extends Component {
  static propTypes = {
    parentAccountId: PropTypes.number,
    accountId: PropTypes.number,
    officeId: PropTypes.number,
    children: PropTypes.func
  }

  constructor (props) {
    super(props)

    const { parentAccountId, accountId, officeId } = props

    extendObservable(this, {
      projectsListingStore: new ProjectsListingStore()
    })

    Object.assign(this.projectsListingStore.query, {
      parentAccountId,
      accountId,
      officeId
    })

    this.projectsListingStore.filter()
  }

  renderResults = ({ loading, error, projects, total }) => {
    if (loading) {
      return <Spinner />
    }

    if (error) {
      return <Error />
    }

    if (projects.length && total) {
      return <ProjectsTable projects={projects} />
    }

    return <Error label={'No projects match the current search parameters'} />
  }

  render () {
    const { projectsListingStore } = this
    const { children } = this.props
    const { total, query } = projectsListingStore

    return (
      <div>
        <div className='project-search-bar'>
          {children({ projectsListingStore, ...this.props })}
        </div>
        {this.renderResults(projectsListingStore)}
        <Pagination
          total={total}
          perPage={10}
          page={query.page}
          onChange={p => projectsListingStore.filter(p)}
        />
      </div>
    )
  }
}

export default observer(Projects)
